// @owners { team: patients }
import pluralize from 'pluralize';

const DOSAGE_FORM_TO_ICON_NAME = {
  gel: 'topical',
  cream: 'topical',
  ointment: 'topical',
  tube: 'topical',
  vial: 'testtube',
  patch: 'patch',
  suppository: 'suppository',
  syringe: 'syringe',
  insert: 'towelette',
  cartridge: 'injectorpen',
  applicator: 'injectorpen',
  pen: 'injectorpen',
  kit: 'injectorpen',
  lozenge: 'pills',
  capsule: 'pills',
  tablet: 'pills',
} as const;

export const getIconNameForDosageForm = (
  dosageForm: string,
): (typeof DOSAGE_FORM_TO_ICON_NAME)[keyof typeof DOSAGE_FORM_TO_ICON_NAME] | '' => {
  const formattedDosageForm = pluralize.singular(dosageForm.toLowerCase());

  for (const baseForm in DOSAGE_FORM_TO_ICON_NAME) {
    if (formattedDosageForm.includes(baseForm)) {
      return DOSAGE_FORM_TO_ICON_NAME[baseForm as keyof typeof DOSAGE_FORM_TO_ICON_NAME];
    }
  }

  return '';
};
